export let MessageBoxActions = /*#__PURE__*/function (MessageBoxActions) {
  MessageBoxActions["Abort"] = "Abort";
  MessageBoxActions["Cancel"] = "Cancel";
  MessageBoxActions["Close"] = "Close";
  MessageBoxActions["Delete"] = "Delete";
  MessageBoxActions["Ignore"] = "Ignore";
  MessageBoxActions["No"] = "No";
  MessageBoxActions["OK"] = "OK";
  MessageBoxActions["Retry"] = "Retry";
  MessageBoxActions["Yes"] = "Yes";
  return MessageBoxActions;
}({});